export default "__VITE_ASSET__COSfY1A8__"